import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalConfigService } from './global-config.service';

export interface IApplicationRegionOption {
  value: string;
  label: string;
}

export interface IApplicationRegionCategory {
  regions: IApplicationRegionOption[];
  category: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/products';
  }

  constructor(
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) {}

  /**
   * Busca as regiões de aplicação disponíveis, agrupadas por categoria
   */
  getApplicationRegions(): Observable<IApplicationRegionCategory[]> {
    return this.http.get<IApplicationRegionCategory[]>(`${this.baseUrl}/application-regions`);
  }
}
